import { useAdministrativeContext } from '../../../../../pages/administrativePanel/administrativePanelContext'
import { ContainerThatCloseOutside } from '../../../../ContainerThatCloseOutside'
import { useRef } from 'react'
import { useFiltered } from '../Context'
import { Regions } from './Regions'
import { FaTimesCircle } from 'react-icons/fa'

import { Container, Country } from './style'


export function FiltersDetailed() {
    const { 
        atLeastTwo, 
        isLoading, 
        openFiltersDetailed,
        openingFiltersDetailed,
    } = useFiltered()
    const { removingFromArrayBusiness } = useAdministrativeContext()
    const ref = useRef(null)

    function removingCountryFromFilter(regions) {
        let idListBusiness = []

        regions.map(region => 
            region.states.map(state => state.business.forEach(business => idListBusiness.push(business.id)))
        )
        
        removingFromArrayBusiness(idListBusiness)
    }


    if(openFiltersDetailed)
        return(
            <ContainerThatCloseOutside 
                ref={ref}
                availableToClick={openFiltersDetailed}
                handleClickOutside={openingFiltersDetailed}
            >
                <Container>
                    
                    {
                        atLeastTwo.map((country) => (
                            <Country 
                                key={country.country}
                                isLoading={isLoading}
                            >
                                <div className='countryBullet'/>

                                <div className='buttonCountry'>
                                    <p>{country.country}</p>
                                    <FaTimesCircle 
                                        className='cleanCountryButton'
                                        onClick={() => removingCountryFromFilter(country.regions)}
                                    />
                                </div>

                                <Regions 
                                    regions={country.regions}
                                />
                            </Country>
                        ))
                    }

                </Container>
            </ContainerThatCloseOutside>
        )
    else 
        return <></>
}
